import { getGlobalParamsListItemLabel } from '@/utils/common'
import store from '@/store'

export const contentTableConfig = {
  title: '',
  propList: [
    {
      prop: 'name',
      label: 'general.name'
    },
    {
      prop: 'tableId',
      label: 'Template',
      formatter: (row) => {
        return getGlobalParamsListItemLabel(row, 'paramTemplate', {
          isNeedPreFix: false
        })
      }
    },
    {
      prop: 'groupId',
      label: 'Template Group',
      formatter: (row) => {
        return getGlobalParamsListItemLabel(row, 'terminalParamGroup', {
          isNeedPreFix: false
        })
      }
    },
    {
      prop: 'tenantId',
      label: 'user.tenant',
      width: 180,
      formatter: (row) => {
        return row ? store.getters.tenantDataMap[row] : ''
      }
    },
    {
      prop: 'description',
      label: 'general.description'
    },
    {
      prop: 'createdTime',
      slotName: 'formatZeroTime',
      label: 'common.app-creation-time'
    },
    {
      label: 'common.app-operation',
      width: '380',
      slotName: 'handler'
    }
  ],
  showIndexColumn: true
}
